import { render, staticRenderFns } from "./BpInput.vue?vue&type=template&id=570582c9&scoped=true&"
import script from "./BpInput.vue?vue&type=script&lang=js&"
export * from "./BpInput.vue?vue&type=script&lang=js&"
import style0 from "./BpInput.vue?vue&type=style&index=0&id=570582c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570582c9",
  null
  
)

export default component.exports